import { getNameDescriptionTableColumn, getTimeTableColumn, getCopyWithContentTableColumn } from '@/utils/common/tableColumn'
import i18n from '@/locales'

export default {
  data () {
    return {
      columns: [
        getNameDescriptionTableColumn({
          resource: 'ratesets',
          onManager: this.onManager,
          title: i18n.t('table.title.rate_set_title'),
          hideField: true,
          edit: true,
          editDesc: true,
          slotCallback: row => {
            return (
              <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{row.name}</side-page-trigger>
            )
          },
        }),
        getCopyWithContentTableColumn({
          field: 'id',
          title: 'ID',
        }),
        getCopyWithContentTableColumn({
          field: 'parent',
          title: this.$t('bill.parent_rateset'),
        }),
        getTimeTableColumn(),
      ],
    }
  },
}
